/* BF2026 · JS da campanha Blue Friday (vanilla, carregado com defer). Ver PLANO-BLUE-FRIDAY.md, F0-T8. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function readStorage(key) {
    try {
      return window.localStorage.getItem(key) || '';
    } catch (e) {
      return '';
    }
  }

  function writeStorage(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (e) {}
  }

  // ---------------------------------------------------------------
  // 1. <bf-countdown data-end="2026-11-30T23:59:00-03:00" data-format="inline|boxes">
  // ---------------------------------------------------------------
  class BfCountdown extends HTMLElement {
    connectedCallback() {
      this.end = Date.parse(this.dataset.end || '');
      this.format = this.dataset.format || 'inline';
      this.ended = false;
      if (isNaN(this.end)) return;
      this.render();
      this.timer = window.setInterval(() => this.render(), 1000);
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
    }

    render() {
      var total = Math.max(0, Math.floor((this.end - Date.now()) / 1000));
      var d = Math.floor(total / 86400);
      var h = Math.floor((total % 86400) / 3600);
      var m = Math.floor((total % 3600) / 60);
      var s = total % 60;

      if (this.format === 'boxes') {
        var labels = [['dias', d], ['horas', h], ['min', m], ['seg', s]];
        this.innerHTML = labels
          .map(function (item) {
            return (
              '<span class="bf-countdown__box"><span class="bf-countdown__num">' +
              pad(item[1]) +
              '</span><span class="bf-countdown__label">' +
              item[0] +
              '</span></span>'
            );
          })
          .join('');
      } else {
        this.textContent = pad(d) + 'd ' + pad(h) + ':' + pad(m) + ':' + pad(s);
      }

      if (total === 0 && !this.ended) {
        this.ended = true;
        window.clearInterval(this.timer);
        this.dispatchEvent(new CustomEvent('bf:countdown-end', { bubbles: true }));
      }
    }
  }

  if (window.customElements && !window.customElements.get('bf-countdown')) {
    window.customElements.define('bf-countdown', BfCountdown);
  }

  // ---------------------------------------------------------------
  // 2. Cupom: [data-bf-coupon] copia, aplica na sessão e guarda o código.
  //    [data-bf-coupon-state="CODIGO"] recebe .is-active quando o código está ativo.
  // ---------------------------------------------------------------
  function refreshCouponStates() {
    var stored = readStorage('bf-coupon');
    document.querySelectorAll('[data-bf-coupon-state]').forEach(function (el) {
      var code = el.getAttribute('data-bf-coupon-state') || stored;
      var matches = !!stored && stored.toUpperCase() === code.toUpperCase();
      // data-bf-active: o carrinho já tem o cupom aplicado (renderizado pelo Liquid)
      el.classList.toggle('is-active', matches || el.hasAttribute('data-bf-active'));
    });
  }

  function flashCoupon(btn) {
    var label = btn.querySelector('[data-bf-coupon-label]') || btn;
    if (!label.dataset.bfOriginal) label.dataset.bfOriginal = label.textContent;
    label.textContent = 'cupom copiado!';
    btn.classList.add('is-copied');
    window.setTimeout(function () {
      label.textContent = label.dataset.bfOriginal;
      btn.classList.remove('is-copied');
    }, 1400);
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-bf-coupon]');
    if (!btn) return;
    event.preventDefault();
    var code = (btn.getAttribute('data-bf-coupon') || '').trim();
    if (!code) return;

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).catch(function () {});
    }
    // só copia quando o botão marca data-bf-coupon-copy-only; senão aplica o código na sessão (cookie discount_code)
    if (!btn.hasAttribute('data-bf-coupon-copy-only')) {
      fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {});
      writeStorage('bf-coupon', code);
      refreshCouponStates();
    }
    flashCoupon(btn);
    showToast('cupom copiado!', code, false);
  });

  // ---------------------------------------------------------------
  // 2a. Cupom aplicado no carrinho: lê o cookie discount_code (gravado pela
  //     Shopify ao aplicar o código) e mostra o rótulo com o X.
  //     Remover = apagar o cookie e recriar o carrinho com os mesmos itens.
  // ---------------------------------------------------------------
  function appliedCouponCode() {
    return (readStorage('bf-coupon') || '').trim().toUpperCase();
  }

  function renderAppliedCoupon() {
    var label = document.querySelector('.bf-cart-coupon__applied');
    if (!label) return;
    var code = appliedCouponCode();
    label.classList.toggle('is-active', !!code);
    var b = label.querySelector('b');
    if (b && code) b.textContent = code;
  }

  function expireCookie(name) {
    document.cookie = name + '=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
  }

  function removeCoupon() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart.items || []).map(function (it) {
          return { id: it.variant_id, quantity: it.quantity, properties: it.properties || {} };
        });
        expireCookie('discount_code');
        expireCookie('cart');
        writeStorage('bf-coupon', '');
        if (!items.length) { window.location.reload(); return; }
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: items })
        }).then(function () { window.location.reload(); });
      })
      .catch(function () { window.location.reload(); });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-bf-coupon-remove]');
    if (!btn) return;
    event.preventDefault();
    btn.disabled = true;
    removeCoupon();
  });

  // ---------------------------------------------------------------
  // 3. Scroll suave: [data-bf-scroll-to="#id"]
  // ---------------------------------------------------------------
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('[data-bf-scroll-to]');
    if (!trigger) return;
    var target = document.querySelector(trigger.getAttribute('data-bf-scroll-to'));
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  });

  // ---------------------------------------------------------------
  // 4. Rotação com fade: [data-bf-fade-rotate] alterna os filhos a cada 3,2s.
  //    CSS (bf-base.css): container grid, filhos com grid-area 1/1 e opacity 0; .is-on = visível.
  //    Pausa com toque ou mouse em cima.
  // ---------------------------------------------------------------
  function initFadeRotate(root) {
    var items = root.children;
    if (items.length < 2 || reduceMotion) {
      if (items.length) items[0].classList.add('is-on');
      return;
    }
    var index = 0;
    var paused = false;
    items[0].classList.add('is-on');
    root.addEventListener('touchstart', function () { paused = true; }, { passive: true });
    root.addEventListener('touchend', function () { paused = false; }, { passive: true });
    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    window.setInterval(function () {
      if (paused || document.hidden) return;
      items[index].classList.remove('is-on');
      index = (index + 1) % items.length;
      items[index].classList.add('is-on');
    }, 3200);
  }

  // ---------------------------------------------------------------
  // 4-topo. Barra de topo (bf-topbar): no mobile troca 1 item por vez com fade.
  //     Intervalo em data-bf-topbar-rotate (segundos, editor). CSS só usa .is-rotating no mobile.
  // ---------------------------------------------------------------
  function initTopbarRotate(bar) {
    if (reduceMotion) return;
    var items = [];
    for (var i = 0; i < bar.children.length; i++) {
      var el = bar.children[i];
      if (el.classList.contains('bf-topbar__block') && !el.classList.contains('bf-topbar__block--desk')) items.push(el);
    }
    if (items.length < 2) return;
    var index = 0;
    bar.classList.add('is-rotating');
    items[0].classList.add('is-on');
    window.setInterval(function () {
      if (document.hidden) return;
      items[index].classList.remove('is-on');
      index = (index + 1) % items.length;
      items[index].classList.add('is-on');
    }, (parseFloat(bar.getAttribute('data-bf-topbar-rotate')) || 5) * 1000);
  }

  // ---------------------------------------------------------------
  // 4a. Mega menu do header (.bf-mega): abre com o mouse ou clique no botão e só fecha
  //     com clique fora ou Esc, para dar tempo de chegar ao painel sem ele sumir.
  // ---------------------------------------------------------------
  function initMegaMenu() {
    var megas = document.querySelectorAll('.bf-mega');
    function close(mega) {
      mega.classList.remove('is-open');
      mega.querySelector('.bf-header__mega-btn').setAttribute('aria-expanded', 'false');
    }
    megas.forEach(function (mega) {
      var btn = mega.querySelector('.bf-header__mega-btn');
      if (!btn) return;
      function open() {
        mega.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
      mega.addEventListener('mouseenter', open);
      btn.addEventListener('click', open);
    });
    if (!megas.length) return;
    document.addEventListener('click', function (event) {
      document.querySelectorAll('.bf-mega.is-open').forEach(function (mega) {
        if (!mega.contains(event.target)) close(mega);
      });
    });
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('.bf-mega.is-open').forEach(close);
    });
  }

  // ---------------------------------------------------------------
  // 4b. Trilho que anda sozinho: [data-bf-autoscroll] rola 1 item a cada 5s e volta ao início no fim.
  //     Só age quando o trilho estoura (mobile). Pausa com toque ou mouse em cima.
  // ---------------------------------------------------------------
  function initAutoScroll(track) {
    if (reduceMotion) return;
    var paused = false;
    track.addEventListener('touchstart', function () { paused = true; }, { passive: true });
    track.addEventListener('touchend', function () { paused = false; }, { passive: true });
    track.addEventListener('mouseenter', function () { paused = true; });
    track.addEventListener('mouseleave', function () { paused = false; });
    window.setInterval(function () {
      if (paused || document.hidden || track.scrollWidth <= track.clientWidth) return;
      var first = track.children[0];
      var second = track.children[1];
      var step = second ? second.offsetLeft - first.offsetLeft : track.clientWidth;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      track.scrollTo({ left: atEnd ? 0 : track.scrollLeft + step, behavior: 'smooth' });
    }, 5000);
  }

  // ---------------------------------------------------------------
  // 5. Toast "adicionado!" após adicionar pelo card (source 'card-product').
  //    Mostra quanto falta para o frete grátis (.goal-progress[data-threshold] em centavos).
  // ---------------------------------------------------------------
  var toastTimer = null;

  function formatBRL(cents) {
    return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  // Toast do protótipo (Mobile.jsx:230-237): título + mensagem + botão "ver" que abre o carrinho (só quando withCartBtn).
  function showToast(title, message, withCartBtn) {
    var toast = document.querySelector('.bf-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'bf-toast';
      toast.setAttribute('role', 'status');
      toast.innerHTML =
        '<span class="bf-toast__text"><b data-bf-toast-title></b><br><span data-bf-toast-msg></span></span>' +
        '<button type="button" class="bf-toast__btn" data-bf-toast-open>ver</button>';
      toast.querySelector('[data-bf-toast-open]').addEventListener('click', function () {
        toast.classList.remove('is-on');
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open();
      });
      document.body.appendChild(toast);
    }
    toast.querySelector('[data-bf-toast-title]').textContent = title;
    toast.querySelector('[data-bf-toast-msg]').textContent = message;
    toast.querySelector('[data-bf-toast-open]').hidden = !withCartBtn;
    toast.classList.add('is-on');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () {
      toast.classList.remove('is-on');
    }, 2600);
  }

  // Os totais do drawer e o #cart-icon-bubble são re-renderizados pela Sections API (cart.js).
  // Aqui só fica a bolinha da barra flutuante mobile, que está fora dessas sections.
  function updateCartTotals(cart) {
    if (!cart || typeof cart.item_count !== 'number') return;
    document.querySelectorAll('[data-bf-cart-dot]').forEach(function (dot) {
      dot.textContent = cart.item_count;
      dot.hidden = cart.item_count === 0;
    });
  }

  function refreshCartTotals(data) {
    if (data && data.cartData && typeof data.cartData.total_price === 'number') {
      updateCartTotals(data.cartData);
      return;
    }
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(updateCartTotals)
      .catch(function () {});
  }

  function onCartUpdate(data) {
    refreshCartTotals(data);
    refreshCouponStates();
    renderAppliedCoupon();
    if (!data || data.source !== 'card-product') return;
    var goal = document.querySelector('.goal-progress');
    var threshold = goal ? parseInt(goal.dataset.threshold, 10) : NaN;
    var total = data.cartData && typeof data.cartData.total_price === 'number'
      ? data.cartData.total_price
      : goal ? parseInt(goal.dataset.total, 10) : NaN;

    var message = 'já está no seu carrinho';
    if (!isNaN(threshold) && !isNaN(total)) {
      var missing = threshold - total;
      message = missing > 0
        ? 'faltam ' + formatBRL(missing) + ' para frete grátis'
        : 'você ganhou frete grátis!';
    }
    showToast('adicionado!', message, true);
  }

  // ---------------------------------------------------------------
  // 6. Adicionar pelo card: [data-add-to-cart="ID"] (handler único; antes ficava em cada card).
  // ---------------------------------------------------------------
  // Envia um corpo para /cart/add.js, abre o drawer e avisa o cart-update.
  function postToCart(body, btn, source) {
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) { return res.json(); })
      .then(function (response) {
        if (response.status) {
          console.error('Erro ao adicionar ao carrinho:', response.description);
          return;
        }
        var drawer = document.querySelector('cart-drawer');
        var drawerItems = document.querySelector('cart-drawer-items');
        var updatePromise = drawerItems && typeof drawerItems.onCartUpdate === 'function'
          ? drawerItems.onCartUpdate()
          : Promise.resolve();
        return updatePromise.then(function () {
          // o "+" do card adiciona sem sair da página (o toast avisa e tem o botão "ver"); o combo abre o drawer
          if (source !== 'card-product' && drawer && typeof drawer.open === 'function') drawer.open();
          return fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cartData) {
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartUpdate, { source: source, cartData: cartData });
              }
            });
        });
      })
      .catch(function (e) {
        console.error('Falha ao adicionar ao carrinho:', e);
      })
      .finally(function () {
        btn.disabled = false;
      });
  }

  function addToCart(btn) {
    if (btn.disabled) return;
    var variantId = parseInt(btn.getAttribute('data-add-to-cart'), 10);
    if (isNaN(variantId)) return;
    postToCart({ id: variantId, quantity: 1 }, btn, 'card-product');
  }

  // 6b. Compre junto (PDP): [data-bf-combo-ids="ID1,ID2"] adiciona os dois de uma vez.
  function addComboToCart(btn) {
    if (btn.disabled) return;
    var ids = (btn.getAttribute('data-bf-combo-ids') || '')
      .split(',')
      .map(function (s) { return parseInt(s, 10); })
      .filter(function (n) { return !isNaN(n); });
    if (!ids.length) return;
    postToCart({ items: ids.map(function (id) { return { id: id, quantity: 1 }; }) }, btn, 'combo-pdp');
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-add-to-cart]');
    if (btn) addToCart(btn);
    var combo = event.target.closest && event.target.closest('[data-bf-combo-ids]');
    if (combo) addComboToCart(combo);
  });

  // troca de foto ao passar o mouse no card (desktop): img[data-hover]
  document.addEventListener('mouseover', function (event) {
    var img = event.target.closest && event.target.closest('img[data-hover]');
    if (!img || window.innerWidth < 1040) return;
    var hoverSrc = img.getAttribute('data-hover');
    if (!hoverSrc) return;
    if (!img.dataset.bfOriginal) img.dataset.bfOriginal = img.getAttribute('src');
    if (img.getAttribute('src') !== hoverSrc) img.setAttribute('src', hoverSrc);
  });
  document.addEventListener('mouseout', function (event) {
    var img = event.target.closest && event.target.closest('img[data-hover]');
    if (!img || !img.dataset.bfOriginal) return;
    if (event.relatedTarget && img.parentNode && img.parentNode.contains(event.relatedTarget)) return;
    img.setAttribute('src', img.dataset.bfOriginal);
  });

  // ---------------------------------------------------------------
  // 7. Navegação mobile (F6-T3): barra do topo ao rolar, busca e menu pela tab bar.
  //    O modal de busca e o drawer continuam sendo do header (details-modal e header-drawer).
  // ---------------------------------------------------------------
  function initMobileNav() {
    var nav = document.querySelector('[data-bf-mobile-nav]');
    if (!nav) return;
    var topfloat = nav.querySelector('[data-bf-topfloat]');
    var isHome = window.location.pathname === '/' || window.location.pathname === '';
    var isPdp = topfloat && topfloat.hasAttribute('data-bf-pdp-bar');

    function updateTopfloat() {
      if (!topfloat) return;
      if (isPdp) {
        // PDP: sempre visível; depois da foto (300px) ganha fundo e o nome do produto (Mobile.jsx:188)
        topfloat.classList.toggle('is-solid', window.scrollY > 300);
        return;
      }
      var show = isHome ? window.scrollY > 130 : true;
      topfloat.classList.toggle('is-visible', show && window.innerWidth < 990);
    }
    window.addEventListener('scroll', function () { window.requestAnimationFrame(updateTopfloat); }, { passive: true });
    updateTopfloat();

    // busca e menu continuam sendo os do bf-header (details-modal e details do drawer)
    nav.addEventListener('click', function (event) {
      // carrinho das barras flutuantes abre o drawer (o cart-drawer.js só intercepta o #cart-icon-bubble)
      var cartBtn = event.target.closest('[data-bf-open-cart]');
      var drawer = document.querySelector('cart-drawer');
      if (cartBtn && drawer && typeof drawer.open === 'function') {
        event.preventDefault();
        drawer.open(cartBtn);
        return;
      }
      // voltar: histórico quando veio de uma página da loja; senão segue o href (coleção do produto)
      var backBtn = event.target.closest('[data-bf-back]');
      if (backBtn && document.referrer.indexOf(window.location.origin) === 0 && window.history.length > 1) {
        event.preventDefault();
        window.history.back();
        return;
      }
      var searchBtn = event.target.closest('[data-bf-open-search]');
      if (searchBtn) {
        var searchToggle = document.querySelector('.bf-header__search > details > summary');
        // no próximo tick: este clique ainda vai subir até o body, e o details-modal fecharia como "clique fora"
        if (searchToggle) window.setTimeout(function () { searchToggle.click(); }, 0);
        return;
      }
      var menuBtn = event.target.closest('[data-bf-open-menu]');
      if (menuBtn) {
        var menuToggle = document.querySelector('.bf-header__drawer > summary');
        if (menuToggle) menuToggle.click();
      }
    });
  }

  // ---------------------------------------------------------------
  // 8. Buscas populares (F6-T1): [data-bf-search-term] preenche o campo do painel de busca.
  // ---------------------------------------------------------------
  document.addEventListener('click', function (event) {
    var chip = event.target.closest && event.target.closest('[data-bf-search-term]');
    if (!chip) return;
    var panel = chip.closest('.search-modal__content');
    var input = panel && panel.querySelector('input[name="q"]');
    if (!input) return;
    input.value = chip.getAttribute('data-bf-search-term') || '';
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.focus();
  });

  // ---------------------------------------------------------------
  // 9. Ordenação da coleção (Collection.jsx): select.facet-filters__sort ganha um dropdown no visual do site.
  //    O select nativo continua no form (o facets.js ouve o evento input dele) e volta a aparecer no mobile (CSS).
  //    O facets.js troca o HTML dos filtros a cada ordenação, então um observer refaz o dropdown.
  // ---------------------------------------------------------------
  var SORT_LABELS = {
    manual: 'em destaque',
    'best-selling': 'mais vendidos',
    'price-ascending': 'menor preço',
    'price-descending': 'maior preço',
    'created-descending': 'lançamentos'
  };
  var CHECK_SVG = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
  var CARET_SVG = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>';

  function sortLabel(option) {
    return SORT_LABELS[option.value] || option.textContent.trim().toLowerCase();
  }

  function enhanceSort(select) {
    if (select.dataset.bfSort) return;
    select.dataset.bfSort = '1';
    var wrap = select.parentElement;
    wrap.classList.add('bf-sort');
    var listId = 'bf-sort-list-' + (select.id || 'sort');
    var current = select.options[select.selectedIndex];

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'bf-sort__btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', listId);
    btn.innerHTML = '<span class="bf-sort__label"></span>' + CARET_SVG;
    btn.querySelector('.bf-sort__label').textContent = sortLabel(current);
    btn.setAttribute('aria-label', 'ordenar por: ' + sortLabel(current));

    var list = document.createElement('ul');
    list.className = 'bf-sort__list';
    list.id = listId;
    list.setAttribute('role', 'listbox');
    list.hidden = true;
    Array.prototype.forEach.call(select.options, function (option) {
      // só as opções do protótipo, mais a que estiver ativa pela URL
      if (!SORT_LABELS[option.value] && option !== current) return;
      var li = document.createElement('li');
      li.className = 'bf-sort__opt';
      li.setAttribute('role', 'option');
      li.setAttribute('aria-selected', option === current ? 'true' : 'false');
      li.dataset.value = option.value;
      li.tabIndex = -1;
      li.innerHTML = '<span></span>' + CHECK_SVG;
      li.querySelector('span').textContent = sortLabel(option);
      list.appendChild(li);
    });

    wrap.appendChild(btn);
    wrap.appendChild(list);

    function open(focusSelected) {
      list.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      var target = list.querySelector('[aria-selected="true"]') || list.firstElementChild;
      if (focusSelected && target) target.focus();
    }
    function close(returnFocus) {
      list.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      if (returnFocus) btn.focus();
    }
    function choose(li) {
      close(true);
      if (li.dataset.value === select.value) return;
      select.value = li.dataset.value;
      select.dispatchEvent(new Event('input', { bubbles: true }));
    }

    btn.addEventListener('click', function () {
      if (list.hidden) open(false); else close(false);
    });
    btn.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        open(true);
      }
      if (event.key === 'Escape' && !list.hidden) {
        event.preventDefault();
        close(false);
      }
    });
    list.addEventListener('click', function (event) {
      var li = event.target.closest('.bf-sort__opt');
      if (li) choose(li);
    });
    list.addEventListener('keydown', function (event) {
      var li = document.activeElement.closest && document.activeElement.closest('.bf-sort__opt');
      if (event.key === 'Escape') { event.preventDefault(); close(true); return; }
      if (event.key === 'Tab') { close(false); return; }
      if (!li) return;
      if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); choose(li); }
      if (event.key === 'ArrowDown' && li.nextElementSibling) { event.preventDefault(); li.nextElementSibling.focus(); }
      if (event.key === 'ArrowUp' && li.previousElementSibling) { event.preventDefault(); li.previousElementSibling.focus(); }
    });
    document.addEventListener('click', function (event) {
      if (!list.hidden && !wrap.contains(event.target)) close(false);
    });
  }

  function initSort() {
    var root = document.getElementById('main-collection-filters');
    if (!root || !document.body.classList.contains('bf')) return;
    var form = root.querySelector('facet-filters-form.facets');
    var bar = document.querySelector('.kit-filter-bar--bf');
    // desktop: a ordenação vai para dentro da faixa de filtros, que fica presa no topo ao rolar (Collection.jsx).
    // O facets.js acha o form pelo id, então continua funcionando lá.
    // ponytail: decide só no carregamento; quem redimensiona de desktop para mobile fica com ela na faixa.
    if (form && bar && window.matchMedia('(min-width: 990px)').matches) {
      form.classList.add('bf-sort-in-bar');
      bar.appendChild(form);
    }
    var run = function () {
      document.querySelectorAll('#main-collection-filters select.facet-filters__sort, .bf-sort-in-bar select.facet-filters__sort').forEach(enhanceSort);
    };
    run();
    [root, form].forEach(function (el) {
      if (el) new MutationObserver(run).observe(el, { childList: true, subtree: true });
    });
  }

  // ---------------------------------------------------------------
  // Inicialização. bf.js é defer e roda antes de cart.js (também defer, no cart-drawer),
  // então o pub/sub só é lido em DOMContentLoaded.
  // ---------------------------------------------------------------
  function init() {
    refreshCouponStates();
    renderAppliedCoupon();
    // o drawer pode ser redesenhado pelo tema depois da inicialização
    window.addEventListener('load', renderAppliedCoupon);
    initMobileNav();
    initSort();
    document.querySelectorAll('[data-bf-fade-rotate]').forEach(initFadeRotate);
    document.querySelectorAll('[data-bf-autoscroll]').forEach(initAutoScroll);
    initMegaMenu();
    document.querySelectorAll('[data-bf-topbar-rotate]').forEach(initTopbarRotate);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
    }
  }

  // bf.js é defer: durante a execução readyState é 'interactive', então espera o DOMContentLoaded.
  if (document.readyState === 'complete') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
